import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { EntryScreen } from "./components/EntryScreen";
import { PageLoadingFallback } from "./components/LoadingFallback";
import { URLSearchParamsHandler } from "./hooks/URLSearchParamsHandler";
import { lazyWithRetry } from "./lib/lazyWithRetry";
import { userIdentifyAtom } from "./store/user";

// Lazy load all page components
const Home = lazyWithRetry(() => import("./pages/Home"));
const Scan = lazyWithRetry(() =>
  import("./pages/Scan").then((module) => ({ default: module.Scan }))
);
const ScanQrCode = lazyWithRetry(() =>
  import("./pages/ScanQrCode").then((module) => ({
    default: module.ScanQrCode,
  }))
);

const Profile = lazyWithRetry(() =>
  import("./pages/user/Profile").then((module) => ({ default: module.Profile }))
);
const Setting = lazyWithRetry(() =>
  import("./pages/user/Setting").then((module) => ({ default: module.Setting }))
);
const User = lazyWithRetry(() => import("./pages/user/User"));
const UserUpdated = lazyWithRetry(() =>
  import("./pages/user/UserUpdated").then((module) => ({
    default: module.UserUpdated,
  }))
);
const VerifyEmail = lazyWithRetry(() =>
  import("./pages/user/verifyEmail").then((module) => ({
    default: module.VerifyEmail,
  }))
);
const VerifyFailed = lazyWithRetry(() =>
  import("./pages/verifyResult/VerifyFailed").then((module) => ({
    default: module.VerifyFailed,
  }))
);
const VerifyGoBack = lazyWithRetry(() =>
  import("./pages/verifyResult/VerifyGoBack").then((module) => ({
    default: module.VerifyGoBack,
  }))
);
const VerifyRegistrationSuccess = lazyWithRetry(() =>
  import("./pages/verifyResult/VerifyRegistrationSuccess").then((module) => ({
    default: module.VerifyRegistrationSuccess,
  }))
);
const VerifySuccess = lazyWithRetry(() =>
  import("./pages/verifyResult/VerifySuccess").then((module) => ({
    default: module.VerifySuccess,
  }))
);


const Email = lazyWithRetry(() =>
  import("./pages/Email").then((module) => ({ default: module.Email }))
);

const ResultPage = lazyWithRetry(() =>
  import("./pages/verifyResult/ResultPage").then((module) => ({
    default: module.ResultPage,
  }))
);

function App() {
  const userIdentify = useAtomValue(userIdentifyAtom);

  const isMobile = /Mobile|Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(
    navigator.userAgent
  );

  useEffect(() => {
    if (!userIdentify && window.location.pathname.includes("/user")) {
      // window.location.href = "/";
    }
  }, [userIdentify]);

  if (!isMobile && window.innerWidth > 1024) {
    return <EntryScreen />;
  }

  return (
    <>
      <BrowserRouter>
        <URLSearchParamsHandler />
        <Suspense fallback={<PageLoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/user" element={<User />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/email" element={<Email />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/user/profile" element={<Profile />} />
            <Route path="/user/setting" element={<Setting />} />
            <Route path="/user/verifyEmail" element={<VerifyEmail />} />
            <Route path="/user/updated" element={<UserUpdated />} />
            <Route path="/verify-failed" element={<VerifyFailed />} />
            <Route path="/verify-success" element={<VerifySuccess />} />
            <Route path="/verify-go-back" element={<VerifyGoBack />} />
            <Route
              path="/verify-registration-success"
              element={<VerifyRegistrationSuccess />}
            />
            <Route path="/scan/qr" element={<ScanQrCode />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        toastOptions={{
          className: "mt-[20px]",
        }}
      />
    </>
  );
}

export default App;
